import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { ScrollToTop } from './components/ScrollToTop';
import { AlertBar } from './components/AlertBar';
import { Footer } from './components/Footer';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { RequestsProvider } from './contexts/RequestsContext';
import { RequireAuth } from './components/auth/RequireAuth';
import { EspaceProvider } from './contexts/EspaceContext';
import { EspaceLayout } from './components/espace/EspaceLayout';
import { DemoBanner } from './components/demo/DemoBanner';
import { Accueil } from './pages/Accueil';
import { MaCarte } from './pages/MaCarte';
import { MesCollectes } from './pages/MesCollectes';
import { CalendrierCollectes } from './pages/CalendrierCollectes';
import { MonProfil } from './pages/MonProfil';
import { MesLoisirs } from './pages/MesLoisirs';
import { AvisNotifications } from './pages/AvisNotifications';
import { ParametresAvis } from './pages/ParametresAvis';
import { MesDemandes } from './pages/MesDemandes';
import { DemandeDetail } from './pages/DemandeDetail';
import { MonEspace } from './pages/MonEspace';
import { MesAnimaux } from './pages/MesAnimaux';
import { Plan } from './pages/Plan';
import { AnimalDetail } from './pages/AnimalDetail';
interface AppProps {
  showAlertBar?: boolean;
  showEvents?: boolean;
  showDemoBanner?: boolean;
}
export function App({
  showAlertBar = true,
  showEvents = true,
  showDemoBanner = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="38m1fe27kzbnd">
      <LanguageProvider data-id="element-1" data-mp="38li6fazwrxlh">
        <AuthProvider data-id="element-2" data-mp="38k6vmr81ppkv">
          <RequestsProvider data-id="element-3" data-mp="38o4gbha9up6v">
          <EspaceProvider data-id="element-4" data-mp="3dkl0y1i9ilf7">
          <div id="accueil" className="min-h-screen w-full bg-white" data-id="element-5" data-mp="3dlw4q1bpjt6b">
            <ScrollToTop data-id="element-6" data-mp="nvssr1axyhud" />
            <div className="sticky top-0 z-40" data-id="element-7" data-mp="nuhicimzqbua">
              {showDemoBanner && <DemoBanner data-id="element-8" data-mp="sudmqizlo5ad" />}
              <Header data-id="element-9" data-mp="stkns46vuk2s" />
              {showAlertBar && <AlertBar data-id="element-10" data-mp="swqbbezv5dwe" />}
            </div>
            <EspaceLayout data-id="element-11" data-mp="35ozexlizgwa">
              <Routes data-id="element-12" data-mp="34x1hg4gh72u">
                <Route path="/" element={<Accueil showEvents={showEvents} data-id="element-14" data-mp="3ud1gzdqblwcq" />} data-id="element-13" data-mp="38kw6ilmzzj5" />
                <Route path="/plan" element={<Plan data-id="element-16" data-mp="3uf5gljh6s977" />} data-id="element-15" data-mp="3uc9inv5c9kir" />
                <Route path="/ma-carte" element={<RequireAuth label="Ma carte numérique" data-id="element-18" data-mp="85ujnspgu14c">
                      <MaCarte data-id="element-19" data-mp="86cqtkdo1zr1" />
                    </RequireAuth>} data-id="element-17" data-mp="d57ep0qhqei0" />
                <Route path="/mes-collectes" element={<RequireAuth label="Mes collectes" data-id="element-21" data-mp="3bo4kd37garrc">
                      <MesCollectes data-id="element-22" data-mp="3qbfwb67jodrz" />
                    </RequireAuth>} data-id="element-20" data-mp="3gja6a20us6ff" />
                <Route path="/mes-collectes/calendrier" element={<RequireAuth label="Le calendrier des collectes" data-id="element-24" data-mp="2xtv8cgggrxf9">
                      <CalendrierCollectes data-id="element-25" data-mp="2sw24hu2mvfi5" />
                    </RequireAuth>} data-id="element-23" data-mp="3ljg2lvi2ih3u" />
                <Route path="/mon-profil" element={<RequireAuth label="Mon profil" data-id="element-27" data-mp="1d4zucwek38t3">
                      <MonProfil data-id="element-28" data-mp="1d5suhej0f029" />
                    </RequireAuth>} data-id="element-26" data-mp="18dhqo0l5eu4f" />
                <Route path="/mes-loisirs" element={<RequireAuth label="Mes loisirs" data-id="element-30" data-mp="13ey35vqwpa9y">
                      <MesLoisirs data-id="element-31" data-mp="1r3zgnxeljbm3" />
                    </RequireAuth>} data-id="element-29" data-mp="ydija70gt9t5" />
                <Route path="/notifications" element={<RequireAuth label="Mes avis et notifications" data-id="element-33" data-mp="1i4cf9blva5t1">
                      <AvisNotifications data-id="element-34" data-mp="1m56364zb7klx" />
                    </RequireAuth>} data-id="element-32" data-mp="1w3lvucdzj1xj" />
                <Route path="/notifications/parametres" element={<RequireAuth label="Mes préférences de communication" data-id="element-36" data-mp="aqiqvgz5t62b">
                      <ParametresAvis data-id="element-37" data-mp="ano95x7j5zcl" />
                    </RequireAuth>} data-id="element-35" data-mp="6onpkch8asoj" />
                <Route path="/mes-demandes" element={<RequireAuth label="Mes demandes" data-id="element-39" data-mp="h7c54yicwb6r">
                      <MesDemandes data-id="element-40" data-mp="h8432fzfel07" />
                    </RequireAuth>} data-id="element-38" data-mp="m6fciplt6thw" />
                <Route path="/mes-demandes/:id" element={<RequireAuth label="Mes demandes" data-id="element-42" data-mp="19vhq9mdbo274">
                      <DemandeDetail data-id="element-43" data-mp="14x6jxlm8k9tn" />
                    </RequireAuth>} data-id="element-41" data-mp="c9u5jyq8b8bf" />
                <Route path="/mon-espace" element={<RequireAuth label="Mon espace citoyen" data-id="element-45" data-mp="vwibd6fm31o5">
                      <MonEspace data-id="element-46" data-mp="vybb01rt4lmn" />
                    </RequireAuth>} data-id="element-44" data-mp="zxam6444temj" />
                <Route path="/mes-animaux" element={<RequireAuth label="Mes animaux" data-id="element-48" data-mp="3gl66yrp5auo1">
                      <MesAnimaux data-id="element-49" data-mp="1w58292a78wun" />
                    </RequireAuth>} data-id="element-47" data-mp="3klyf1hma6tiq" />
                <Route path="/mes-animaux/:id" element={<RequireAuth label="Mes animaux" data-id="element-51" data-mp="254v1bhfghqkj">
                      <AnimalDetail data-id="element-52" data-mp="253a9hzkj0lqd" />
                    </RequireAuth>} data-id="element-50" data-mp="2058np6vpu8b7" />
                <Route path="*" element={<Accueil showEvents={showEvents} data-id="element-54" data-mp="2evg0p72yez4i" />} data-id="element-53" data-mp="29xo5o470iww3" />
              </Routes>
            </EspaceLayout>
            <Footer data-id="element-55" data-mp="2jthqsbysryph" />
          </div>
          </EspaceProvider>
          </RequestsProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>;
}